module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hollow-dots-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.dotsStyles), function(ds, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      style: (ds)
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb7339c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/HollowDotsSpinner.vue
// module id = 254
// module chunks = 1